import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="pt-20 min-h-screen flex items-center justify-center bg-background-50">
      <div className="text-center px-4">
        <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-100 mb-6">
          <i className="ri-error-warning-line text-4xl text-foreground-400"></i>
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
          页面未找到
        </h1>
        <p className="text-sm text-foreground-500 mb-6 max-w-md mx-auto">
          您访问的页面不存在或已被移除，请检查链接是否正确。
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-line"></i> 返回首页
        </Link>
      </div>
    </div>
  );
}